import { BaseApi } from './base.api'

export class ChatSeedAdminApi extends BaseApi {
	constructor() {
		super('api/admin/chat-seed')
	}

	async getSettings() {
		return this.get('/settings')
	}

	async updateSettings(data) {
		return this.put('/settings', data)
	}

	async getThreads({ status = 'pending' } = {}) {
		const params = new URLSearchParams({ status })
		return this.get(`/threads?${params.toString()}`)
	}

	async approveThread(conversationId) {
		return this.post(`/threads/${conversationId}/approve`, {})
	}

	async rejectThread(conversationId, rejectReason = '') {
		return this.post(`/threads/${conversationId}/reject`, { rejectReason })
	}

	async approveDraft(id) {
		return this.post(`/drafts/${id}/approve`, {})
	}

	async rejectDraft(id, rejectReason = '') {
		return this.post(`/drafts/${id}/reject`, { rejectReason })
	}

	async editDraft(id, data) {
		return this.put(`/drafts/${id}`, data)
	}

	async getPersonas() {
		return this.get('/personas')
	}

	async bootstrapPersonas() {
		return this.post('/personas/bootstrap', {})
	}

	async refreshPersonas() {
		return this.post('/personas/refresh', {})
	}

	async generateDrafts() {
		return this.post('/drafts/generate', {})
	}

	async getDailyMetrics({ from, to, tz } = {}) {
		const params = new URLSearchParams()
		if (from) params.set('from', from)
		if (to) params.set('to', to)
		if (tz) params.set('tz', tz)
		const qs = params.toString()
		return this.get(`/metrics/daily${qs ? `?${qs}` : ''}`)
	}
}
